import { render, staticRenderFns } from "./WtLeaderboard.vue?vue&type=template&id=77cb664e&scoped=true&lang=pug&"
import script from "./WtLeaderboard.vue?vue&type=script&lang=js&"
export * from "./WtLeaderboard.vue?vue&type=script&lang=js&"
import style0 from "./WtLeaderboard.vue?vue&type=style&index=0&id=77cb664e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cb664e",
  null
  
)

export default component.exports